import React from "react";

function DessertIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="42"
      fill="none"
      viewBox="0 0 40 42"
    >
      <path
        stroke="#ACA9A7"
        strokeLinejoin="round"
        d="M24 4.967c0 2.19-1.79 3.966-4 3.966s-4-1.776-4-3.966m8 0C24 2.776 22.21 1 20 1s-4 1.776-4 3.967m8 0c0 .142-.008.283-.022.422 8.144 1.75 14.308 8.777 14.672 17.292l-.03-.518c.03.213.047.432.047.654 0 2.555-2.09 4.627-4.667 4.627M16 4.967c0 .142.008.283.025.42C8.102 7.091 2.054 13.784 1.393 21.984l-.01.149c-.032.223-.05.451-.05.684 0 2.555 2.09 4.627 4.667 4.627m28 0c-2.46 0-4.476-1.887-4.654-4.282l-.015-.317-.01.317c-.179 2.395-2.194 4.282-4.654 4.282m9.333 0c.698 0 1.361-.152 1.956-.424l-2.623 13.647H6.667L4.044 27.02A4.683 4.683 0 006 27.444m28 0c-2.577 0-4.667-2.072-4.667-4.627M6 27.444c2.451 0 4.46-1.873 4.652-4.255l.012-.344.015.317c.179 2.395 2.194 4.282 4.654 4.282m-9.333 0c2.577 0 4.667-2.072 4.667-4.627 0 2.555 2.089 4.627 4.666 4.627m0 0c2.46 0 4.476-1.887 4.654-4.282l.01-.317m-4.664 4.6c2.568 0 4.65-2.058 4.665-4.6m0 0l.015.317c.178 2.395 2.193 4.282 4.654 4.282m-4.67-4.6l.003-.027c0 2.555 2.09 4.627 4.667 4.627m0 0c2.577 0 4.666-2.072 4.666-4.627m0 0l.005-.168c-.006.056-.005.112-.005.168zm-1 8.594l-.666 5.289m-7.334-5.289V36.7m-8-5.289L13 36.7"
      ></path>
    </svg>
  );
}

export default DessertIcon;
